import { render, staticRenderFns } from "./SkeletonComboAdditions.vue?vue&type=template&id=5ac1b139&"
import script from "./SkeletonComboAdditions.vue?vue&type=script&lang=js&"
export * from "./SkeletonComboAdditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports